const dayGroupings = {
    'all_days': ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
    'monday_to_friday': ['monday', 'tuesday', 'wednesday', 'thursday', 'friday']
};

export default dayGroupings;
